const SITE_ORIGIN = 'https://tk2023.tokyo';
const SITE_TITLE = 'teco（テコ）エロい飲み会ができるギャラ飲みアプリ';
const PUBLIC_DESCRIPTION =
  'teco（テコ）は、大人の飲み会やデートを楽しみたい方とテコガールをつなぐ、18歳以上向けのギャラ飲みサービスです。';
const APP_DESCRIPTION =
  'teco（テコ）の会員向けWebアプリです。テコガールの検索、メッセージ、予約に利用できます。';
const SOCIAL_IMAGE_URL = `${SITE_ORIGIN}/images/logo512.png`;

export type SeoMetadata = {
  title: string;
  description: string;
  canonicalUrl: string;
  robots: string;
  imageUrl: string;
};

export const getSeoMetadata = (pathname: string): SeoMetadata => {
  const isIndexablePage = ['/', '/search', '/search/'].includes(pathname);

  return {
    title: SITE_TITLE,
    description: isIndexablePage ? PUBLIC_DESCRIPTION : APP_DESCRIPTION,
    canonicalUrl: `${SITE_ORIGIN}/search`,
    robots: isIndexablePage
      ? 'index,follow,max-image-preview:large,max-snippet:-1'
      : 'noindex,follow,noarchive',
    imageUrl: SOCIAL_IMAGE_URL,
  };
};

const upsertMeta = (
  attribute: 'name' | 'property',
  key: string,
  content: string,
) => {
  let element = document.head.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`,
  );

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.content = content;
};

const upsertCanonical = (canonicalUrl: string) => {
  let element = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );

  if (!element) {
    element = document.createElement('link');
    element.rel = 'canonical';
    document.head.appendChild(element);
  }

  element.href = canonicalUrl;
};

export const applySeoMetadata = (metadata: SeoMetadata) => {
  document.documentElement.lang = 'ja';
  document.title = metadata.title;
  upsertCanonical(metadata.canonicalUrl);
  upsertMeta('name', 'description', metadata.description);
  upsertMeta('name', 'robots', metadata.robots);
  upsertMeta('property', 'og:locale', 'ja_JP');
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:site_name', 'teco（テコ）');
  upsertMeta('property', 'og:title', metadata.title);
  upsertMeta('property', 'og:description', metadata.description);
  upsertMeta('property', 'og:url', metadata.canonicalUrl);
  upsertMeta('property', 'og:image', metadata.imageUrl);
  upsertMeta('name', 'twitter:card', 'summary');
  upsertMeta('name', 'twitter:title', metadata.title);
  upsertMeta('name', 'twitter:description', metadata.description);
  upsertMeta('name', 'twitter:image', metadata.imageUrl);
};
